import { useState } from "react";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { SoundWaveParticles } from "@/components/landing/SoundWaveParticles";
import { HeroSection } from "@/components/landing/HeroSection";
import { EarlyAdoptersSection } from "@/components/landing/EarlyAdoptersSection";
import { ProblemSection } from "@/components/landing/ProblemSection";
import { HowItWorksSection } from "@/components/landing/HowItWorksSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { ClientViewSection } from "@/components/landing/ClientViewSection";
import { ScienceSection } from "@/components/landing/ScienceSection";
import { PricingSection } from "@/components/landing/PricingSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { ManifestoSection } from "@/components/landing/ManifestoSection";
import { FinalCTASection } from "@/components/landing/FinalCTASection";

const LandingPage = () => {
  const openModal = () => {
    window.location.href = "https://app.antropia.fit";
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white overflow-x-hidden">
      <Header onOpenModal={openModal} />
      
      {/* Hero with particles */}
      <div className="relative">
        <SoundWaveParticles />
        <HeroSection onOpenModal={openModal} />
      </div>
      
      <EarlyAdoptersSection />
      <ProblemSection />
      <HowItWorksSection />
      <FeaturesSection />
      <ClientViewSection />
      <ScienceSection />
      <PricingSection onOpenModal={openModal} />
      <FAQSection />
      <ManifestoSection />
      <FinalCTASection onOpenModal={openModal} />
      <Footer />
    </div>
  );
};

export default LandingPage;
